/* global WeixinJSBridge:false */
import wx from "wx";
import axios from "./req";

const bridgeReady = function (fn) {
    return function () {
        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', fn, false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', fn);
                document.attachEvent('onWeixinJSBridgeReady', fn);
            }
        } else {
            fn();
        }
    }
}

const hideBar = bridgeReady(() => {
    WeixinJSBridge.call('hideToolbar');
});

const api = ["updateAppMessageShareData", "updateTimelineShareData"];
const wxReq = function (fn) {
    axios({
        url: '/official/jssdk',
        method: 'POST',
        data: {
            url: location.href,
            jsApiList: api
        },
        loadingText: false
    }).then(res => {
        if(typeof res === "string") {
            res = JSON.parse(res);
        }
        let ticket = res;
        wx.config({
            beta: true,
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: ticket.appId, // 必填，公众号的唯一标识
            timestamp: ticket.timestamp, // 必填，生成签名的时间戳
            nonceStr: ticket.nonceStr, // 必填，生成签名的随机串
            signature: ticket.signature,// 必填，签名，见附录1
            jsApiList: api // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        typeof fn === "function" && fn();
    })

}
const wxConf = function (title, desc, logo) {
    wxReq(() => {
        share(title, desc, logo);
    })
}

const share = function (title, desc, logo, link) {
    let imgUrl = logo || "https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/image/logo.png";
    title = title || document.title;
    desc = desc || "一键咨询招生办，关注心仪大学，随时接收最新的招生动态。";
    link = link || location.href;
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
            title, // 分享标题
            desc, // 分享描述
            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl // 分享图标
        });
        wx.updateTimelineShareData({
            title, // 分享标题
            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl // 分享图标
        });
    });
}
const previewImage = (current, urls)  => {
    wx.previewImage({
        current, // 当前显示图片的http链接
        urls // 需要预览的图片http链接列表
    });
};

export {
    hideBar,
    bridgeReady,
    wxConf,
    previewImage,
    wxReq,
    share
}
